export const local = {
    isMockNafath: true, 
    apiUrl: 'https://localhost:7068',
    chatHubUrl:'https://localhost:44318/chatHub',
    websocketUrlInfraLink: 'wss://localhost:7068/ws',
    notificationUrl: 'https://localhost:7043/api/inapp-notification',
    nafathMockUrl: 'http://localhost:7067',
    websocketUrlUserManagement: 'wss://localhost:7067/ws',
    nafathUrl: 'https://localhost:7067',         
    landLordURL:'http://localhost:4201/requests',
    mnoURL:'http://localhost:4202/requests',
    nhpURL:'http://localhost:4203/requests',
    adminURL:'http://localhost:4204/requests',
    cstURL:'http://localhost:4205/requests',
    eSignUrl:'http://localhost:5263',
    publicSite:'http://localhost:4200',
    paymentApi: 'http://localhost:5043'
    // isMockNafath: true,
    // apiUrl: 'https://gateway-gravitee.qa.abraj.azm-dev.com/ibs-building',
    // chatHubUrl:'https://gateway-gravitee.qa.abraj.azm-dev.com/chat-api/chatHub',
    // websocketUrlInfraLink: 'wss://gateway-gravitee.qa.abraj.azm-dev.com/ibs-building/ws',
    // notificationUrl: 'https://gateway-gravitee.qa.abraj.azm-dev.com/ns/api/inapp-notification',
    // nafathMockUrl: 'https://gateway-gravitee.qa.abraj.azm-dev.com/auth',
    // nafathUrl: 'https://auth.qa.abraj.azm-dev.com/api',
    // websocketUrlUserManagement: 'wss://gateway-gravitee.qa.abraj.azm-dev.com/auth/ws',
    // landLordURL:'http://localhost:4201/requests',
    // mnoURL:'http://localhost:4202/requests',
    // nhpURL:'http://localhost:4203/requests',
    // adminURL:'http://localhost:4204/requests',
    // cstURL:'http://localhost:4205/requests',
    // eSignUrl:'https://gateway-gravitee.qa.abraj.azm-dev.com/esign',
    // publicSite:'http://localhost:4200',
    // paymentApi: 'https://gateway-gravitee.qa.abraj.azm-dev.com/payments'
};

export const development = {
    isMockNafath: true,
    apiUrl: 'https://api.gravitee.dev.abraj.azm-dev.com/ibs-building',
    chatHubUrl:'https://localhost:44318/chatHub',
    websocketUrlInfraLink: 'wss://api.gravitee.dev.abraj.azm-dev.com/ibs-building/ws',
    notificationUrl: 'https://api.gravitee.dev.abraj.azm-dev.com/ns/api/inapp-notification',
    nafathMockUrl: 'https://api.gravitee.dev.abraj.azm-dev.com/auth', 
    nafathUrl: 'https://auth.dev.abraj.azm-dev.com/api', 
    websocketUrlUserManagement: 'wss://api.gravitee.dev.abraj.azm-dev.com/auth/ws',
    landLordURL:'https://landlord.dev.abraj.azm-dev.com/requests',
    mnoURL:'https://seeker.dev.abraj.azm-dev.com/requests',
    nhpURL:'https://provider.dev.abraj.azm-dev.com/requests',
    adminURL:'https://admin.dev.abraj.azm-dev.com/requests',
    cstURL:'https://cst.dev.abraj.azm-dev.com/requests',
    eSignUrl:'https://api.gravitee.dev.abraj.azm-dev.com/esign',
    publicSite:'https://public.dev.abraj.azm-dev.com/',
    paymentApi: 'https://api.gravitee.dev.abraj.azm-dev.com/payments'
}

export const staging = {
	isMockNafath: true,
    apiUrl: 'https://gateway-gravitee.qa.abraj.azm-dev.com/ibs-building',
    chatHubUrl:'https://gateway-gravitee.qa.abraj.azm-dev.com/chat-api/chatHub',
    websocketUrlInfraLink: 'wss://gateway-gravitee.qa.abraj.azm-dev.com/ibs-building/ws',
    notificationUrl: 'https://gateway-gravitee.qa.abraj.azm-dev.com/ns/api/inapp-notification',
    nafathMockUrl: 'https://gateway-gravitee.qa.abraj.azm-dev.com/auth',
    nafathUrl: 'https://auth.qa.abraj.azm-dev.com/api',
    websocketUrlUserManagement: 'wss://gateway-gravitee.qa.abraj.azm-dev.com/auth/ws',
    landLordURL:'https://landlord.qa.abraj.azm-dev.com/requests',
    mnoURL:'https://seeker.qa.abraj.azm-dev.com/requests',
    nhpURL:'https://provider.qa.abraj.azm-dev.com/requests',
    adminURL:'https://admin.qa.abraj.azm-dev.com/requests',
    eSignUrl:'https://gateway-gravitee.qa.abraj.azm-dev.com/esign',
    cstURL:'https://cst.qa.abraj.azm-dev.com/requests',
    publicSite:'https://public.qa.abraj.azm-dev.com',
    paymentApi: 'https://gateway-gravitee.qa.abraj.azm-dev.com/payments'
};

export const uat = {
    isMockNafath: true,
    apiUrl: 'https://gateway-gravitee.uat.infralink.sa/ibs-building',
    chatHubUrl:'https://gateway-gravitee.uat.infralink.sa/chat-api/chatHub',
    websocketUrlInfraLink: 'wss://gateway-gravitee.uat.infralink.sa/ibs-building/ws',
    notificationUrl: 'https://gateway-gravitee.uat.infralink.sa/ns/api/inapp-notification',
    nafathMockUrl: 'https://gateway-gravitee.uat.infralink.sa/auth',
    websocketUrlUserManagement: 'wss://gateway-gravitee.uat.infralink.sa/auth/ws',
    nafathUrl: 'https://gateway-gravitee.uat.infralink.sa/auth',
    landLordURL:'https://landlord.uat.infralink.sa/requests',
    mnoURL:'https://mno.uat.infralink.sa/requests',
    nhpURL:'https://nhp.uat.infralink.sa/requests',
    adminURL:'https://admin.uat.infralink.sa/requests',
    cstURL:'https://cst.uat.infralink.sa/',
    eSignUrl:'https://gateway-gravitee.uat.infralink.sa/esign',
    publicSite:'https://public.uat.infralink.sa/',
    paymentApi: 'https://gateway-gravitee.uat.infralink.sa/payments'
}

export const production = {
    isMockNafath: true,
    apiUrl: 'https://gateway-gravitee.infrareg.sa/ibs-building',
    chatHubUrl:'https://gateway-gravitee.infrareg.sa/chat-api/chatHub',
    websocketUrlInfraLink: 'wss://gateway-gravitee.infrareg.sa/ibs-building/ws',
    notificationUrl: 'https://gateway-gravitee.infrareg.sa/ns/api/inapp-notification',
    nafathMockUrl: 'https://gateway-gravitee.infrareg.sa/auth',
    websocketUrlUserManagement: 'wss://gateway-gravitee.infrareg.sa/auth/ws',
    nafathUrl: 'https://gateway-gravitee.infrareg.sa/auth',
    landLordURL:'https://landlord.infrareg.sa/requests',
    mnoURL:'https://seeker.infrareg.sa/requests',
    nhpURL:'https://provider.infrareg.sa/requests',
    adminURL:'https://admin.infrareg.sa/requests',
    cstURL:'https://cst.infrareg.sa/',
    eSignUrl:'https://gateway-gravitee.infrareg.sa/esign',
    publicSite:'https://public.infrareg.sa/',
    paymentApi: 'https://gateway-gravitee.infrareg.sa/payments'
};

